import React, { FunctionComponent } from 'react';

import { SettingsEnableDisable } from '@components/settings/shared/settings-enable-disable';

interface EmbedAssetProps {
  defaultEnabled: boolean | null;
}

const EmbedAsset: FunctionComponent<EmbedAssetProps> = ({ defaultEnabled }) => (
  <SettingsEnableDisable
    defaultEnabled={defaultEnabled === null ? true : defaultEnabled}
    description={bfTranslate(
      'This setting must be enabled for Brandguide use. Disabling it will result in a degraded Brandguide experience.'
    )}
    errorTitle={bfTranslate('Error updating CDN Embed Links setting. Please contact support.')}
    id="embed-asset-setting"
    successTitle={bfTranslate('CDN Embed Links updated!')}
    title={bfTranslate('CDN Embed Links')}
    updateResourceKey="embedAsset"
  />
);

export default EmbedAsset;
